/**
 * The ONE mapper from a `stories` row to what the storefront player and card
 * expect (2026-09-12).
 *
 * There were five copies of this object literal — two in the story page, three
 * in BrandsHeroSection — each rebuilding the story field by field. Adding
 * `videoContentType` (without which Safari refuses to play an uploaded video,
 * because our CDN serves every blob as application/octet-stream) meant editing
 * all five, which is exactly how the storefront product mappers kept losing
 * fields. One function now, so a new field arrives everywhere at once.
 */

import type { Comment, Story } from "./types";

export function toStoryComments(rows: any[] | undefined | null): Comment[] {
  if (!Array.isArray(rows)) return [];
  return rows.map((comment: any) => ({
    id: comment._id,
    user: comment.userName,
    avatar: comment.userAvatar,
    text: comment.text,
    timestamp: comment.timestamp,
  }));
}

export function toStoryView(
  row: any,
  opts: { comments?: any[] | null; fallbackAvatar?: string } = {},
): Story {
  return {
    id: row._id,
    _id: row._id,
    title: row.title ?? "",
    description: row.description ?? "",
    thumbnailUrl: row.thumbnailUrl ?? "",
    videoUrl: row.videoUrl ?? "",
    videoType: row.videoType,
    videoContentType: row.videoContentType ?? undefined,
    // A linked YouTube/TikTok story has no duration of ours to show. "0:00" on
    // the card was a lie — an empty string lets the badge hide itself.
    duration: row.duration || "",
    views: row.views ?? 0,
    uploadDate: row.uploadDate,
    author: row.author ?? "",
    authorAvatar: row.authorAvatar || opts.fallbackAvatar || "",
    comments: toStoryComments(opts.comments),
  };
}
